import React from "react";
import styles from "./taskbar-ticket-card-spinner.module.scss";

const cssClassName = "taskbar-ticket-card-spinner";

export const TaskbarTicketCardSpinner = () => {
  return (
    <div className={styles[cssClassName]}>
      <svg
        className="MuiCircularProgress-svg css-1idz92c-MuiCircularProgress-svg"
        viewBox="0 0 44 44"
      >
        <circle
          className="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate MuiCircularProgress-circleDisableShrink css-79nvmn-MuiCircularProgress-circle"
          cx="22"
          cy="22"
          r="20.2"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.6"
          strokeDasharray="126.68"
          strokeDashoffset="37.9"
        ></circle>
      </svg>
    </div>
  );
};
